import { Grid, styled, SxProps, Theme } from '@mui/material';
import { SecondaryButton } from 'sharedComponents/Buttons';
import { useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import NearMeIcon from '@mui/icons-material/NearMe';
import { MobileDrawerButtonGroupProps } from './types';
import Chip from '@mui/material/Chip';

export const MobileDrawerControlButtonGroup: React.FC<MobileDrawerButtonGroupProps> = ({
  buttonTitles = ['Submit'],
  onClickHandlers,
  activeDrawers,
  showActiveCount = false,
  activeCount = 0,
}) => {
  const theme = useTheme();

  const icons: Record<string, React.ReactNode> = {
    Search: <SearchIcon />,
    Location: <NearMeIcon />,
    Filters: <FilterListIcon />,
  };

  return (
    <ButtonGroupContainer container justifyContent="center" wrap="nowrap">
      {buttonTitles.map((title, index) => (
        <Grid key={index} item xs={12 / buttonTitles.length}>
          <SecondaryButton
            size="medium"
            startIcon={icons[title] || null}
            sx={buttonStyles(theme, activeDrawers[index])}
            onClick={onClickHandlers[index]}
            iconColor={activeDrawers[index] ? theme.palette.primary.main : 'inherit'}
          >
            {title}
            {showActiveCount && activeCount > 0 && (
              <FilterCountChip label={activeCount} color="primary" size="small" />
            )}
          </SecondaryButton>
        </Grid>
      ))}
    </ButtonGroupContainer>
  );
};

const ButtonGroupContainer = styled(Grid)(({ theme }) => ({
  justifyContent: 'center',
  columnGap: theme.spacing(1),
  flexWrap: 'nowrap',
}));

export const buttonStyles = (theme: Theme, isActive: boolean): SxProps<Theme> => ({
  display: 'flex',
  height: '40px',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.gray.mediumDark,
  border: `1px solid ${isActive ? theme.palette.primary.main : theme.palette.gray.darker}`,
  borderRadius: theme.spacing(1),
  fontSize: '14px',
  width: '100%',
});

const FilterCountChip = styled(Chip)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  alignContent: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  minWidth: theme.spacing(2.5),
  height: theme.spacing(2.5),
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.body3.fontSize,
  '.MuiChip-label': {
    padding: 0,
  },
}));
